export default __webpack_public_path__ + "static/media/crossbar-green.b07eefa7.svg";